import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useCloneProphetPage } from '../../api/clonePage';

import { ClonePageForm } from './ClonePageForm';

import { prophetTypes } from '@/features/prophet';
import { Departments, Platforms } from '@/types';

type Props = {
  page: prophetTypes.Page;
  platform: Platforms;
  department: Departments;
};

export const CloneModal = NiceModal.create(({ page, platform, department }: Props) => {
  const modal = useModal();

  const { mutate, isLoading } = useCloneProphetPage({
    pageId: page._id,
    config: { onSuccess: modal.hide },
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Clone page"
    >
      <ClonePageForm
        isLoading={isLoading}
        onSubmit={(data) => mutate({ pageId: page._id, ruleIds: data.rules })}
        platform={platform}
        department={department}
        pageId={page._id}
      />
    </Modal>
  );
});
